import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string;
          email: string;
          full_name: string | null;
          company_name: string | null;
          phone: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id: string;
          email: string;
          full_name?: string | null;
          company_name?: string | null;
          phone?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          email?: string;
          full_name?: string | null;
          company_name?: string | null;
          phone?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
      orders: {
        Row: {
          id: string;
          user_id: string;
          order_number: string;
          service_type: string;
          property_type: string | null;
          room_count: number | null;
          style_preference: string | null;
          turnaround_time: string | null;
          total_price: number | null;
          status: string;
          dropbox_link: string | null;
          notes: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          user_id: string;
          order_number: string;
          service_type: string;
          property_type?: string | null;
          room_count?: number | null;
          style_preference?: string | null;
          turnaround_time?: string | null;
          total_price?: number | null;
          status?: string;
          dropbox_link?: string | null;
          notes?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          user_id?: string;
          order_number?: string;
          service_type?: string;
          property_type?: string | null;
          room_count?: number | null;
          style_preference?: string | null;
          turnaround_time?: string | null;
          total_price?: number | null;
          status?: string;
          dropbox_link?: string | null;
          notes?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
      order_images: {
        Row: {
          id: string;
          order_id: string;
          image_url: string;
          image_type: string;
          room_name: string | null;
          is_processed: boolean;
          processed_url: string | null;
          created_at: string;
        };
        Insert: {
          id?: string;
          order_id: string;
          image_url: string;
          image_type: string;
          room_name?: string | null;
          is_processed?: boolean;
          processed_url?: string | null;
          created_at?: string;
        };
        Update: {
          id?: string;
          order_id?: string;
          image_url?: string;
          image_type?: string;
          room_name?: string | null;
          is_processed?: boolean;
          processed_url?: string | null;
          created_at?: string;
        };
      };
    };
  };
};
